import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface WrapperProps {
  $error?: boolean;
  $disabled?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  --padding-block: ${size(1)};
  --padding-inline: ${size(1)};
  --border-color: var(--c-input-border);
  --font-size: 14; // Unitless value representing px
  --line-height: 1.2; // Required to prevent text clipping

  min-height: ${(props) => props.theme.distances.inputHeight};
  padding: var(--padding-block) 0;
  color: var(--c-input-text);
  line-height: var(--line-height);
  border-bottom: 1px solid var(--border-color-override, var(--border-color));
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: var(--border-radius);

  ${({ $error }) =>
    $error &&
    css`
      --border-color-override: var(--c-input-error-border);
      --label-color-override: var(--c-input-error-text);
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.37;
    `}
`;

export const Label = styled.div`
  margin-bottom: ${size(0.25)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--label-color-override, var(--c-input-label));
  font-size: ${(props) => props.theme.font.size.xsmall};
`;

export const ValueWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--padding-inline);
`;

export const Value = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  hyphens: auto;
  font-size: calc(var(--font-size) * 1px);
`;
